/**
 * 日時質問ルールの日数の最大値。
 * 100年でも 365 * 100 = 36500 なので、5桁（99999）あれば十分。
 */
export const DATETIME_RULE_MAX_VALUE = 99999
